var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.error)?_c('div',{staticClass:"status"},[_vm._v(" The USDA API is currently experiencing difficulties ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }